import React, { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAlertMessage, setPaymentSuccess } from './store/dataslice';

const Success = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();


    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const raporti = searchParams.get('raporti');
        if (raporti) {
            dispatch(setAlertMessage(raporti));
        }
        navigate("/");
        dispatch(setPaymentSuccess(true));
    }, [navigate]);

    return (
        <Fragment />
    );
}

export default Success;
